import { zodSchemes } from '@approvalmax/utils';
import { z } from 'zod';

const additionalDocumentsSchema = z.object({
    proofOfFunds: z.array(zodSchemes.fileRecord).optional(),
    other: z.array(zodSchemes.fileRecord).optional(),
});

export const schema = z
    .object({
        additionalDocuments: additionalDocumentsSchema,
    })
    .passthrough();
